import { atom } from "@mongez/react-atom";
import type { CheckoutData } from "../types";

export const checkoutAtom: any = atom<CheckoutData>({
  key: "checkout",
  default: {},
});
